import React from "react";
import { useNavigate } from 'react-router-dom';
import Tech_resume from '../assets/Tech Resume.pdf';
const Utilities = () => {
    return (
        <div>
        </div>
    )
}

const EmailButton = () => {
    const navigate = useNavigate();

    const handleEmailClick = () => {
        navigate('/email');
    };

    return (
        <button className="main-page-btns" onClick={handleEmailClick}>
            Email Me
        </button>
    );
};
const ResumeButton = () => {
    return (
        <a href={Tech_resume} target="_blank"
            rel="noopener noreferrer">
            <button className="main-page-btns right-side-btn" style={{ float: 'left' }}>
                Resume
            </button>
        </a>
    );
};
const PortfolioButton = () => {
    const navigate = useNavigate();

    const handleEmailClick = () => {
        navigate('/portfolio');
    };

    return (
        <button className="main-page-btns right-side-btn" style={{ float: 'right' }} onClick={handleEmailClick}>
            Portfolio
        </button>
    );
};

const GoBackButton = () => {
    const navigate = useNavigate();

    const handleEmailClick = () => {
        navigate('/');
    };

    return (
        <button className="main-page-btns right-side-btn" style={{float: 'right' }} onClick={handleEmailClick}>
            Go Back
        </button>
    );
};

export { EmailButton, ResumeButton, PortfolioButton, GoBackButton, Utilities };